<script>
const label = [
  {
    "value": null,
    "label": "程序设计入门",
    "children": [
      {
        "value": 1,
        "label": "顺序结构"
      },
      {
        "value": 2,
        "label": "条件分支"
      },
      {
        "value": 3,
        "label": "循环结构"
      },
      {
        "value": 4,
        "label": "循环嵌套"
      },
      {
        "value": 5,
        "label": "数组"
      },
      {
        "value": 6,
        "label": "字符串"
      },
      {
        "value": 7,
        "label": "函数"
      },
      {
        "value": 8,
        "label": "结构体"
      },
      {
        "value": 9,
        "label": "数据统计"
      },
      {
        "value": 10,
        "label": "打印图形"
      },
      {
        "value": 11,
        "label": "数学函数"
      },
      {
        "value": 12,
        "label": "位运算"
      }
    ]
  },
  {
    "value": null,
    "label": "基础算法",
    "children": [
      {
        "value": 12,
        "label": "进制"
      },
      {
        "value": 14,
        "label": "枚举"
      },
      {
        "value": 15,
        "label": "模拟"
      },
      {
        "value": 16,
        "label": "贪心"
      },
      {
        "value": 17,
        "label": "二分"
      },
      {
        "value": 18,
        "label": "差分"
      },
      {
        "value": 19,
        "label": "前缀和"
      },
      {
        "value": 20,
        "label": "递归"
      },
      {
        "value": 21,
        "label": "高精度"
      }
    ]
  },
  {
    "value": null,
    "label": "基础数据结构",
    "children": [
      {
        "value": 22,
        "label": "STL"
      },
      {
        "value": 23,
        "label": "队列"
      },
      {
        "value": 24,
        "label": "栈"
      },
      {
        "value": 25,
        "label": "单调栈"
      },
      {
        "value": 26,
        "label": "单调队列"
      },
      {
        "value": 27,
        "label": "离散化"
      },
      {
        "value": 28,
        "label": "并查集"
      },
      {
        "value": 29,
        "label": "树状数组"
      },
      {
        "value": 30,
        "label": "线段树"
      }
    ]
  },
  {
    "value": null,
    "label": "搜索算法",
    "children": [
      {
        "value": 31,
        "label": "深度优先搜索"
      },
      {
        "value": 32,
        "label": "广度优先搜索"
      },
      {
        "value": 33,
        "label": "搜索剪枝"
      }
    ]
  },
  {
    "value": null,
    "label": "动态规划",
    "children": [
      {
        "value": 34,
        "label": "递推"
      },
      {
        "value": 35,
        "label": "动态规划入门"
      },
      {
        "value": 36,
        "label": "背包问题"
      },
      {
        "value": 37,
        "label": "高维状态DP"
      },
      {
        "value": 38,
        "label": "状态压缩DP"
      },
      {
        "value": 39,
        "label": "区间DP"
      },
      {
        "value": 40,
        "label": "环形DP"
      },
      {
        "value": 41,
        "label": "DAG上的DP"
      },
      {
        "value": 42,
        "label": "树形DP"
      },
      {
        "value": 43,
        "label": "数位DP"
      },
      {
        "value": 44,
        "label": "概率DP"
      }
    ]
  },
  {
    "value": null,
    "label": "图论",
    "children": [
      {
        "value": 45,
        "label": "图论基础"
      },
      {
        "value": 46,
        "label": "拓扑排序"
      },
      {
        "value": 47,
        "label": "最短裤"
      },
      {
        "value": 48,
        "label": "最小生成树"
      },
      {
        "value": 49,
        "label": "最近公共祖先"
      },
      {
        "value": 50,
        "label": "树的直径"
      },
      {
        "value": 51,
        "label": "树的中心"
      }
    ]
  },
  {
    "value": null,
    "label": "数论",
    "children": [
      {
        "value": 52,
        "label": "质数判断"
      },
      {
        "value": 53,
        "label": "分解质因数"
      },
      {
        "value": 54,
        "label": "最大公约数"
      },
      {
        "value": 55,
        "label": "质数筛"
      },
      {
        "value": 56,
        "label": "欧拉函数"
      },
      {
        "value": 57,
        "label": "中国剩余定理"
      },
      {
        "value": 58,
        "label": "欧几里得算法"
      },
      {
        "value": 59,
        "label": "扩展欧几里得算法"
      },
      {
        "value": 60,
        "label": "博弈论"
      },
      {
        "value": 61,
        "label": "逆元"
      }
    ]
  },
  {
    "value": null,
    "label": "字符串",
    "children": [
      {
        "value": 62,
        "label": "KMP"
      },
      {
        "value": 63,
        "label": "扩展KMP"
      },
      {
        "value": 64,
        "label": "字典树"
      },
      {
        "value": 65,
        "label": "AC 自动机"
      },
      {
        "value": 66,
        "label": "Manacher"
      },
      {
        "value": 67,
        "label": "后缀数组"
      },
      {
        "value": 68,
        "label": "哈希"
      }
    ]
  },
  {
    "value": null,
    "label": "模板题",
    "children": [
      {
        "value": 69,
        "label": "数据结构"
      },
      {
        "value": 70,
        "label": "动态规划"
      },
      {
        "value": 71,
        "label": "图论"
      },
      {
        "value": 72,
        "label": "数论"
      },
      {
        "value": 73,
        "label": "字符串"
      }
    ]
  }
]

export default {
  label
}
</script>